import Community from "@/components/sections/Community";

export default function CommunityPage() {
  return (
    <div>
      <Community />
    </div>
  );
}
